import React, { type FC } from 'react'
import { styled } from '@linaria/react'
import { type ColorValue, colors } from '../styles/colors'
import { Typography, type FontSize, type FontWeight } from './Typography'

export const StatusLabel: FC<{
  label: string
  dotColor: ColorValue
  textColor?: ColorValue
  fontSize?: FontSize
  fontWeight?: FontWeight
  className?: string
}> = ({
  label,
  dotColor,
  fontSize = 14,
  fontWeight = 400,
  className,
  textColor = colors.white,
}) => {
  return (
    <Container className={className}>
      <StatusDot color={dotColor} />

      <Typography fontSize={fontSize} fontWeight={fontWeight} color={textColor}>
        {label}
      </Typography>
    </Container>
  )
}

const Container = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`

const StatusDot = styled.div<{ color: ColorValue }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${props => props.color};
  flex-shrink: 0;
`
